import { useQuery } from '@tanstack/react-query';
import { fetchProductOfferings } from '@services/productOfferingService';
import type { Plan, CategoryType } from '@t/productOffering.types';

const groupByCategory = (plans: Plan[] | undefined): Record<CategoryType, Plan[]> => {
  const grouped: Record<CategoryType, Plan[]> = {
    Bundle: [],
    Internet: [],
    Video: [],
    Phone: [],
    EV: [],
  };

  if (!plans) return grouped;

  for (const plan of plans) {
    if (plan.typeName in grouped) {
      grouped[plan.typeName].push(plan);
    }
  }

  return grouped;
};

export const useProductOfferings = (sessionId: string, homeId: string) => {
  const query = useQuery<Plan[]>({
    queryKey: ['productOfferings', sessionId, homeId],
    queryFn: () => fetchProductOfferings(sessionId, homeId),
    enabled: !!sessionId && !!homeId,
  });

  const plansByCategory = groupByCategory(query.data);

  return {
    data: query.data,
    plansByCategory,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
};
